if (!customElements.get('error-notifier')) {
    class ErrorNotifier extends HTMLElement {

        constructor() {
            super();
            this._iteration = 0;
            this.iterationContainer = this.querySelector('[data-iteration]');
        }

        set iteration(val) {
            this._iteration = val;
            this.iterationContainer.innerHTML = val;
        }

        get iteration() {
            return this._iteration;
        }

        connectedCallback() {
            document.addEventListener('error-notifier:show', this.handleShow.bind(this));
            document.addEventListener('error-notifier:hide', this.handleHide.bind(this));
            document.addEventListener('error-notifier:update', this.handleUpdate.bind(this));
            document.addEventListener('error-notifier:step', this.handleStep.bind(this));
        }

        disconnectedCallback() {
            document.removeEventListener('error-notifier:show', this.handleShow.bind(this));
            document.removeEventListener('error-notifier:hide', this.handleHide.bind(this));
            document.removeEventListener('error-notifier:update', this.handleUpdate.bind(this));
            document.removeEventListener('error-notifier:step', this.handleStep.bind(this));
        }

        handleShow() {
            this.setAttribute('open', '');
        }

        handleHide() {
            this.removeAttribute('open');
            setTimeout(() => {
                this.iteration = 0;
            }, 500)
        }

        handleUpdate({detail}) {
            this.iteration = detail;
        }

        handleStep() {
            this.iteration = this.iteration + 1;
        }
    }

    customElements.define('error-notifier', ErrorNotifier);
}